import axios from './axios'

import config from './config'
/*
 * 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 */
export const getToken = () => {
  return axios({
    url: '/service/gettoken',
    method: 'get'
  })
}

export const login = params => {
  return axios({
    url: '/account/login',
    method: 'post',
    data: params
  })
}
export const mobilelogin = params => {
  return axios({
    url: '/account/mobilelogin',
    method: 'post',
    data: params
  })
}

export const validateCode = config.baseURL + 'validateCode'

export const lockUser = params => {
  return axios({
    url: '/account/lock',
    method: 'post',
    data: params
  })
}
export const unLockUser = params => {
  return axios({
    url: '/account/unlock',
    method: 'post',
    data: params
  })
}
export const deleteUser = params => {
  return axios({
    url: '/account/delete',
    method: 'post',
    data: params
  })
}

export const adminLogin = params => {
  return axios({
    url: '/adminuser/login',
    method: 'post',
    data: params
  })
}
export const register = params => {
  return axios({
    url: '/account/register',
    method: 'post',
    data: params
  })
}

export const changePassword = params => {
  return axios({
    url: '/account/changepassword',
    method: 'post',
    data: params
  })
}
export const adminChangePassword = params => {
  return axios({
    url: '/adminuser/changepassword',
    method: 'post',
    data: params
  })
}
export const getUser = params => {
  return axios({
    url: '/account/select',
    method: 'post',
    data: params
  })
}

export const getDevice = params => {
  return axios({
    url: '/device/query',
    method: 'post',
    data: params
  })
}
export const getPType = params => {
  return axios({
    url: '/ptype/query',
    method: 'post',
    data: params
  })
}
export const savePType = params => {
  return axios({
    url: '/ptype/save',
    method: 'post',
    data: params
  })
}
export const deletePType = params => {
  return axios({
    url: '/ptype/delete',
    method: 'post',
    data: params
  })
}

export const getRepairShopType = params => {
  return axios({
    url: '/repairshoptype/query',
    method: 'post',
    data: params
  })
}
export const saveRepairShopType = params => {
  return axios({
    url: '/repairshoptype/save',
    method: 'post',
    data: params
  })
}
export const deleteRepairShopType = params => {
  return axios({
    url: '/repairshoptype/delete',
    method: 'post',
    data: params
  })
}

export const getRepairShop = params => {
  return axios({
    url: '/repairshop/query',
    method: 'post',
    data: params
  })
}
export const saveRepairShop = params => {
  return axios({
    url: '/repairshop/save',
    method: 'post',
    data: params
  })
}
export const deleteRepairShop = params => {
  return axios({
    url: '/repairshop/delete',
    method: 'post',
    data: params
  })
}

export const getRepair = params => {
  return axios({
    url: '/repair/query',
    method: 'post',
    data: params
  })
}
export const saveRepair = params => {
  return axios({
    url: '/repair/save',
    method: 'post',
    data: params
  })
}
export const deleteRepair = params => {
  return axios({
    url: '/repair/delete',
    method: 'post',
    data: params
  })
}
export const deleteIdsRepairShop = params => {
  return axios({
    url: '/repair/deleteIds',
    method: 'post',
    data: params
  })
}
export const getRepairBypage = params => {
  return axios({
    url: '/Repair/selectpaged',
    method: 'post',
    data: params
  })
}
export const dispatchRepair = params => {
  return axios({
    url: '/Repair/dispatch',
    method: 'post',
    data: params
  })
}
export const approvalRepair = params => {
  return axios({
    url: '/Repair/approval',
    method: 'post',
    data: params
  })
}
export const descriptionRepair = params => {
  return axios({
    url: '/Repair/description',
    method: 'post',
    data: params
  })
}
export const adminGetRepair = params => {
  return axios({
    url: '/Repair/select',
    method: 'post',
    data: params
  })
}
export const getDType = params => {
  return axios({
    url: '/dtype/query',
    method: 'post',
    data: params
  })
}
export const selectDType = params => {
  return axios({
    url: '/dtype/select',
    method: 'post',
    data: params
  })
}
export const saveDType = params => {
  return axios({
    url: '/dtype/save',
    method: 'post',
    data: params
  })
}
export const deleteDType = params => {
  return axios({
    url: '/dtype/delete',
    method: 'post',
    data: params
  })
}
export const getDClassify = params => {
  return axios({
    url: '/dclassify/query',
    method: 'post',
    data: params
  })
}
export const selectDClassify = params => {
  return axios({
    url: '/dclassify/select',
    method: 'post',
    data: params
  })
}
export const saveDClassify = params => {
  return axios({
    url: '/dclassify/save',
    method: 'post',
    data: params
  })
}
export const deleteDClassify = params => {
  return axios({
    url: '/dclassify/delete',
    method: 'post',
    data: params
  })
}
export const getDModel = params => {
  return axios({
    url: '/dmodel/query',
    method: 'post',
    data: params
  })
}
export const selectDModel = params => {
  return axios({
    url: '/dmodel/select',
    method: 'post',
    data: params
  })
}
export const saveDModel = params => {
  return axios({
    url: '/dmodel/save',
    method: 'post',
    data: params
  })
}
export const deleteDModel = params => {
  return axios({
    url: '/dmodel/delete',
    method: 'post',
    data: params
  })
}
export const getAdminUser = params => {
  return axios({
    url: '/adminuser/query',
    method: 'post',
    data: params
  })
}
export const addAdminUser = params => {
  return axios({
    url: '/adminuser/add',
    method: 'post',
    data: params
  })
}
export const lockAdminUser = params => {
  return axios({
    url: '/adminuser/lock',
    method: 'post',
    data: params
  })
}
export const unLockAdminUser = params => {
  return axios({
    url: '/adminuser/unlock',
    method: 'post',
    data: params
  })
}
export const deleteAdminUser = params => {
  return axios({
    url: '/adminuser/delete',
    method: 'post',
    data: params
  })
}
export const adminGetDevice = params => {
  return axios({
    url: '/device/select',
    method: 'post',
    data: params
  })
}
export const getDeviceBypage = params => {
  return axios({
    url: '/device/selectpaged',
    method: 'post',
    data: params
  })
}
export const deviceConfirm = params => {
  return axios({
    url: '/device/confirm',
    method: 'post',
    data: params
  })
}
export const deviceRegist = params => {
  return axios({
    url: '/device/regist',
    method: 'post',
    data: params
  })
}
export const deviceUnRegist = params => {
  return axios({
    url: '/device/unregist',
    method: 'post',
    data: params
  })
}
export const deviceDeleteRegist = params => {
  return axios({
    url: '/device/deleteregist',
    method: 'post',
    data: params
  })
}
export const deviceApproval = params => {
  return axios({
    url: '/device/approval',
    method: 'post',
    data: params
  })
}
export const deviceReject = params => {
  return axios({
    url: '/device/reject',
    method: 'post',
    data: params
  })
}
export const deviceSave = params => {
  return axios({
    url: '/device/save',
    method: 'post',
    data: params
  })
}
export const deviceCheckImport = params => {
  return axios({
    url: '/device/checkimport',
    method: 'post',
    data: params
  })
}
export const deviceCancelPCertificate = params => {
  return axios({
    url: '/device/cancelpcertificate',
    method: 'post',
    data: params
  })
}
export const deviceImport = params => {
  return axios({
    url: '/device/import',
    method: 'post',
    data: params
  })
}
export const deviceDelete = params => {
  return axios({
    url: '/device/delete',
    method: 'post',
    data: params
  })
}
export const getBarcodeSort = () => {
  return axios({
    url: '/barcode/getsort',
    method: 'get'
  })
}
export const saveBarcodeSort = params => {
  return axios({
    url: '/barcode/savesort',
    method: 'post',
    data: params
  })
}
export const scanBarcode = form => {
  return axios({
    url: '/barcode/scan',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    transformRequest: [
      function() {
        return form
      }
    ],
    date: form
  })
}
export const uploadFile = form => {
  return axios({
    url: '/file/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    transformRequest: [
      function() {
        return form
      }
    ],
    date: form
  })
}
export const uploadCertificateFile = form => {
  return axios({
    url: '/file/upload/Certificate',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    transformRequest: [
      function() {
        return form
      }
    ],
    date: form
  })
}
export const getFile = params => {
  return axios({
    url: '/file/query/' + params,
    method: 'get'
  })
}
export const adminGetFile = params => {
  return axios({
    url: '/file/select/' + params,
    method: 'get'
  })
}
// 默认全部导出
export default {
  mobilelogin,
  login,
  validateCode,
  register,
  changePassword,
  getUser,
  getDevice,
  getDeviceBypage,
  getToken,
  deviceRegist,
  deviceUnRegist,
  deviceConfirm,
  deviceApproval,
  deviceDeleteRegist,
  deviceReject,
  deviceDelete,
  deviceSave,
  scanBarcode,
  uploadFile,
  uploadCertificateFile,
  adminLogin,
  adminChangePassword,
  adminGetDevice,
  getPType,
  savePType,
  deletePType,
  getDType,
  selectDType,
  saveDType,
  deleteDType,
  getDClassify,
  selectDClassify,
  saveDClassify,
  deleteDClassify,
  getDModel,
  selectDModel,
  saveDModel,
  deleteDModel,
  deviceCheckImport,
  deviceImport,
  deviceCancelPCertificate,
  getFile,
  adminGetFile,
  getAdminUser,
  addAdminUser,
  lockAdminUser,
  unLockAdminUser,
  deleteAdminUser,
  lockUser,
  unLockUser,
  deleteUser,
  getBarcodeSort,
  saveBarcodeSort,
  getRepairShopType,
  saveRepairShopType,
  deleteRepairShopType,

  getRepairShop,
  saveRepairShop,
  deleteRepairShop,

  getRepair,
  saveRepair,
  deleteRepair,
  getRepairBypage,
  dispatchRepair,
  approvalRepair,
  descriptionRepair,
  adminGetRepair
}



// WEBPACK FOOTER //
// ./src/http/interface.js